export default [
  {
    id: '4',
    parentId: '0',
    title: '团队管理',
    path: '/services/team',
    type: 2,
    component: '/comm-pages/mine/mine',
    isHidden: false,
    icon: 'kl-team'
  }
]
